<template>
  <section class="py-20 sm:py-28 bg-white">
    <div class="sm:px-6 lg:px-8">
      <div class="text-center mb-12 sm:mb-16">
        <h2 class="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-5 leading-tight tracking-tight">
          {{ $t('featureLanding.title') }}
        </h2>
        <p class="text-base sm:text-lg text-gray-500 max-w-2xl mx-auto leading-relaxed">
          {{ $t('featureLanding.subtitle') }}
        </p>
      </div>

      <div class="grid md:grid-cols-3 gap-6 lg:gap-8 max-w-5xl mx-auto">
        <router-link
          v-for="product in products"
          :key="product.key"
          :to="product.to"
          class="group flex flex-col rounded-2xl border border-gray-200 p-6 sm:p-8 hover:border-indigo-200 hover:shadow-lg transition-all duration-200"
        >
          <div
            class="w-11 h-11 rounded-xl flex items-center justify-center mb-5"
            :class="product.iconBg"
          >
            <component :is="product.icon" class="w-6 h-6" :class="product.iconColor" />
          </div>
          <h3 class="text-xl font-bold text-gray-900 mb-2">
            {{ $t(`featureLanding.products.${product.key}.title`) }}
          </h3>
          <p class="text-sm text-gray-500 leading-relaxed flex-1 mb-6">
            {{ $t(`featureLanding.products.${product.key}.description`) }}
          </p>
          <span class="inline-flex items-center gap-2 text-sm font-semibold text-gray-900 group-hover:text-indigo-600 transition-colors">
            {{ $t(`featureLanding.products.${product.key}.cta`) }}
            <svg class="w-4 h-4 transition-transform group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </span>
        </router-link>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed, markRaw } from 'vue'
import { useI18n } from 'vue-i18n'
import {
  CpuChipIcon,
  UserGroupIcon,
  BuildingOffice2Icon,
} from '@heroicons/vue/24/outline'

const { locale } = useI18n()

const products = computed(() => [
  {
    key: 'saas',
    to: locale.value === 'en' ? '/property-management-software' : '/software-gestion-coliving',
    icon: markRaw(CpuChipIcon),
    iconBg: 'bg-indigo-50',
    iconColor: 'text-indigo-600',
  },
  {
    key: 'leads',
    to: '/leads-marketplace',
    icon: markRaw(UserGroupIcon),
    iconBg: 'bg-emerald-50',
    iconColor: 'text-emerald-600',
  },
  {
    key: 'partners',
    to: { path: '/', hash: '#partner-services-section' },
    icon: markRaw(BuildingOffice2Icon),
    iconBg: 'bg-purple-50',
    iconColor: 'text-purple-600',
  },
])
</script>
